<template>
  <div
    class="flex items-center justify-end gap-2 px-6 py-4 border-t"
    :class="props.class"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  class?: string
}

const props = defineProps<Props>()
</script>
